import { requestApi } from "./api";

export interface DashboardTrend {
  month: string;
  orders: number;
  constructions: number;
  workers: number;
  clients: number;
}

export interface DashboardRecentOrder {
  code: string;
  title: string;
  clientName: string;
  requestedStartDate: string;
  status: string;
}

export interface DashboardOverview {
  totalOrders: number;
  totalConstructions: number;
  totalWorkers: number;
  totalClients: number;
  trends: DashboardTrend[];
  recentOrders: DashboardRecentOrder[];
}

export const getDashboardOverview = () => requestApi<DashboardOverview>("/admin/dashboard");
